// components
import RichText from '@/components/utilities/RichText';
import VisibleLoading from '@/components/utilities/VisibleLoading';

const BannerBlock = ({ bannerBlockContent }) => {
  return (
    <VisibleLoading delay={100}>
      {({ ref, className }) => (
        <div
          ref={ref}
          className={`mx-auto mb-6 w-[90vw] rounded-3xl bg-[linear-gradient(86deg,#E6D4FF_43.25%,#CED7FF_97.88%)] px-4 py-10 text-center shadow-2xl/15 xl:w-(--container-width) xl:p-20 ${className || ''}`.trim()}
        >
          <h4 className="mx-auto max-w-[812px]">
            <RichText>{bannerBlockContent}</RichText>
          </h4>
        </div>
      )}
    </VisibleLoading>
  );
};
export default BannerBlock;
